// Pre-translated UI strings. Key = original Cyrillic, Value = translation.
// ~100 strings × 5 languages. Zero API calls for these.

const translations: Record<string, Record<string, string>> = {
  en: {
    'Манастир Градац': 'Gradac Monastery',
    'О Манастиру': 'About the Monastery',
    'О МАНАСТИРУ ГРАДАЦ': 'ABOUT GRADAC MONASTERY',
    'Подкатегорије': 'Subcategories',
    'Фото галерија': 'Photo Gallery',
    'Галерија': 'Gallery',
    'Новости': 'News',
    'Јавне испоруке': 'Public Deliveries',
    'Долина јоргована': 'Valley of the Lilacs',
    'Задужбина Свете краљице Јелене Анжујске': 'Foundation of Holy Queen Jelena Anžujska',
    'Православни манастир из XIII века, смештен у долини реке Ибар на обронцима Голије.': 'An Orthodox monastery from the 13th century, nestled in the Ibar River valley on the slopes of Golija.',
    'Навигација': 'Navigation',
    'Почетна': 'Home',
    'Контакт': 'Contact',
    'Брвеник, Рашка, Србија': 'Brvenik, Raška, Serbia',
    '© 2026 Манастир Градац. Сва права задржана.': '© 2026 Gradac Monastery. All rights reserved.',
    'Фотографије: Светлана Дингарац': 'Photos: Svetlana Dingarac',
    'Богослужбени Распоред': 'Liturgy Schedule',
    'Учитавање...': 'Loading...',
    'Покушај поново': 'Try Again',
    'Грешка при учитавању распореда.': 'Error loading schedule.',
    'Грешка при учитавању.': 'Error loading.',
    'Напомена испод наслова (опционо):': 'Note below the title (optional):',
    'Нпр. важи за наредни месец / током поста / ...': 'E.g. valid for next month / during fasting / ...',
    'Ако оставите празно, напомена се неће приказивати.': 'If left empty, the note will not be displayed.',
    'дан (опционо)': 'day (optional)',
    'Дан': 'Day',
    'време': 'time',
    'Време': 'Time',
    'Назив службе': 'Service name',
    'Важно': 'Important',
    'Обриши': 'Delete',
    'Додај ново богослужење:': 'Add new service:',
    'Важна служба (празник / главна литургија)': 'Important service (feast day / main liturgy)',
    'Када је ово укључено, назив службе ће бити приказан црвеном бојом како би се важне службе лакше уочиле.': 'When enabled, the service name will be displayed in red to highlight important services.',
    'Донирајте манастиру': 'Donate to the Monastery',
    'Контакт за донације и помоћ манастиру': 'Contact for donations and monastery support',
    'Манастир Градац — донације за обнову манастира': 'Gradac Monastery — donations for monastery restoration',
    'Унесите контакт информације...': 'Enter contact information...',
    'Сваки ред = нови ред. Телефони се аутоматски линкују.': 'Each line = new line. Phone numbers are auto-linked.',
    'Чување...': 'Saving...',
    'Сачувај': 'Save',
    'Откажи': 'Cancel',
    'Сачувано ✓': 'Saved ✓',
    'Измени': 'Edit',
    'НОВОСТИ МАНАСТИРА ГРАДАЦ': 'GRADAC MONASTERY NEWS',
    'Читати даље': 'Read more',
    'Обрисати ову вест?': 'Delete this news item?',
    'Уреди': 'Edit',
    '+ Додај вест': '+ Add News',
    'СВЕ НОВОСТИ': 'ALL NEWS',
    'Додај нову вест:': 'Add new article:',
    'Датум (нпр. 15. март 2026.)': 'Date (e.g. March 15, 2026)',
    'Наслов вести': 'News title',
    'Кратак текст...': 'Short text...',
    'Кратак текст': 'Short text',
    'Додај': 'Add',
    'URL слике': 'Image URL',
    'Наслов': 'Title',
    'Опис': 'Description',
    'Прочитај више': 'Read more',
    '+ Додај': '+ Add',
    'СВА ГАЛЕРИЈА': 'FULL GALLERY',
    'Уреди ✎': 'Edit ✎',
    'Како до нас': 'How to Find Us',
    'Наручи производ': 'Order Product',
    'Затвори': 'Close',
    'Хвала!': 'Thank You!',
    'Ваша наруџбина је послата. Контактираћемо вас у најкраћем року.': 'Your order has been sent. We will contact you shortly.',
    'Наручивање': 'Ordering',
    'Без плаћања картицом — оставите контакт и договарамо се око испоруке.': 'No card payment — leave your contact and we will arrange delivery.',
    'Име је обавезно.': 'Name is required.',
    'Телефон је обавезан.': 'Phone is required.',
    'Грешка при слању. Покушајте поново.': 'Error sending. Please try again.',
    'Име и презиме': 'Full name',
    'Телефон': 'Phone',
    'Имејл': 'Email',
    'Адреса за испоруку': 'Delivery address',
    'Количина': 'Quantity',
    'Напомена': 'Note',
    'Слање...': 'Sending...',
    'Пошаљи наруџбину': 'Send Order',
    '← Назад': '← Back',
    'Вест није пронађена.': 'News not found.',
    'Уреди вест ✎': 'Edit news ✎',
    '404 — Страница није пронађена': '404 — Page Not Found',
    'Страница није пронађена': 'Page Not Found',
    'Страница коју тражите не постоји или је премештена.': 'The page you are looking for does not exist or has been moved.',
    'Назад на почетну': 'Back to Home',
    'Не могу учитати вест.': 'Cannot load news.',
    'Наслов је обавезан.': 'Title is required.',
    'Грешка при чувању. Покушај поново.': 'Error saving. Try again.',
    'Уреди вест': 'Edit News',
    'Нова вест': 'New Article',
    'Датум': 'Date',
    'нпр. 15. март 2026.': 'e.g. March 15, 2026',
    'Кратак текст (excerpt)': 'Short text (excerpt)',
    'Пуни текст': 'Full text',
    'Предпреглед': 'Preview',
    'Наслов вести...': 'News title...',
    'Кратак опис...': 'Short description...',
    'Не могу учитати ставку.': 'Cannot load item.',
    'Уреди ставку галерије': 'Edit Gallery Item',
    'Нова ставка галерије': 'New Gallery Item',
    'Обрисати ову наруџбину?': 'Delete this order?',
    'Приступ дозвољен само администратору.': 'Admin access only.',
    'НАРУЏБИНЕ': 'ORDERS',
    '← Производи': '← Products',
    'Још нема наруџбина.': 'No orders yet.',
    'Ново': 'New',
    'Решено': 'Resolved',
    'Купац': 'Customer',
    'Адреса': 'Address',
    'Означи решено ✓': 'Mark resolved ✓',
    'Врати на ново ↺': 'Revert to new ↺',
    'Обриши ✕': 'Delete ✕',
    'Додај вест': 'Add News',
    'Наручи': 'Order',
    'Фрескопис': 'Frescoes',
    'Фреске Богородичине цркве — ремек-дела српског средњовековног сликарства XIII века': 'Frescoes of the Church of the Theotokos — masterpieces of 13th-century Serbian medieval painting',
    'Пре и после рестаурације': 'Before and After Restoration',
    'Превуците клизач лево-десно да упоредите изглед фресака пре и после рестаурације': 'Drag the slider left and right to compare the appearance of the frescoes before and after restoration',
    'Фреске пре рестаурације': 'Frescoes Before Restoration',
    'Фреске после рестаурације': 'Frescoes After Restoration',
    'Преглед слике': 'Image Preview',
    'Ктиторска композиција': 'Founder\'s Composition',
    'Успење Пресвете Богородице': 'Dormition of the Most Holy Theotokos',
    'Купање Богомладенца': 'Bathing of the Divine Infant',
    'Композиција са пастирима': 'Composition with Shepherds',
    'Свети пророк Гедеон': 'Holy Prophet Gideon',
    'Нерукотворени образ': 'The Image Not Made by Hands',
    'Јеванђелиста': 'Evangelist',
    'Непознати светитељ': 'Unknown Saint',
    'Ктиторска композиција — детаљ': 'Founder\'s Composition — detail',
    'Ктиторска композиција — детаљ фреске': 'Founder\'s Composition — detail of the fresco',
    'Распеће': 'Crucifixion',
    'Рођење Христово': 'Nativity of Christ',
    'Све фреске Богородичине цркве настале су у исто време. Нажалост, градачки фрескопис великим делом је оштећен у току дугог периода када је црква била откривена и напуштена.': 'All frescoes of the Church of the Theotokos were created at the same time. Unfortunately, the Gradac fresco painting was largely damaged during the long period when the church was uncovered and abandoned.',
    'Најбоље је сачувана фреска Благовести која се налази у линети главног портала.': 'The best-preserved fresco is the Annunciation, located in the lunette of the main portal.',
    'Зидови припрате били су украшени циклусом сцена из живота Пресвете Богородице. Композиција Благовести била је насликана на источном зиду припрате, али сада се на том месту може видети само крило архангела и део ореола Богородице. Преостале композиције овог циклуса су: Анина молитва у врту, Сусрет Јоакима и Ане, Рођење Богородице и Миловање, Одбијање дарова, Благослов свештеника и Ваведење.': 'The walls of the narthex were decorated with a cycle of scenes from the life of the Most Holy Theotokos. The composition of the Annunciation was painted on the east wall of the narthex, but now only the wing of the archangel and part of the halo of the Theotokos can be seen in that place. The remaining compositions of this cycle are: Anne\'s Prayer in the Garden, Meeting of Joachim and Anne, Nativity of the Theotokos and Caressing, Rejection of Gifts, Blessing of the Priests and Presentation.',
    'Јужна капела Богородичине цркве посвећена је светом Симеону Немањи и у њој је био насликан живот овог светитеља од одласка у Свету Гору до смрти и преноса његових моштију у Студеницу.': 'The southern chapel of the Church of the Theotokos is dedicated to Saint Simeon Nemanja and in it was painted the life of this saint from his departure to the Holy Mountain until his death and the transfer of his relics to Studenica.',
    'Између фресака на јужној и северној страни наоса постигнут је посебан сликарски склад. На северном зиду, у оквиру композиције Успења Пресвете Богородице, представљено је како Христос прихвата Богородицу као тек рођену бебу у своје наручје. Наспрам те фреске, на јужном зиду наоса, налази се композиција Рођења и детињства Христовог, на којој је осликано како Пресвета Богородица држи малог Христа у свом наручју, док са праведним Јосифом путује за Египат.': 'A special painterly harmony was achieved between the frescoes on the south and north sides of the nave. On the north wall, within the composition of the Dormition of the Most Holy Theotokos, Christ is depicted receiving the Theotokos like a newborn baby in His arms. Opposite that fresco, on the south wall of the nave, is the composition of the Nativity and Childhood of Christ, which depicts the Most Holy Theotokos holding the infant Christ in Her arms as she travels to Egypt with the righteous Joseph.',
    'Овај необични паралелизам на поменутим фрескама рефлектује чудесни Божји домострој спасења и дубоко уметничко промишљање градачких фрескописаца и ктиторке о том Божанском уређењу.': 'This unusual parallelism in the mentioned frescoes reflects the miraculous divine economy of salvation and the deep artistic reflection of the Gradac painters and the founder on that divine order.',
    'Ктиторска композиција се у немањићким задужбинама налази на југозападном зиду наоса, изнад гробнице ктитора. На ктиторској композицији градачке цркве Пресвета Богородица и свети краљ Стефан Првовенчани заступају ктиторски пар пред Господом Исусом Христом. Композиција се наставља приказом фигура краља Драгутина, краља Милутина и Драгутинове жене Кателине.': 'The founder\'s composition in Nemanjić foundations is located on the southwest wall of the nave, above the tomb of the founder. In the founder\'s composition of the Gradac church, the Most Holy Theotokos and the holy king Stefan the First-Crowned intercede for the founding couple before the Lord Jesus Christ. The composition continues with the figures of King Dragutin, King Milutin and Dragutin\'s wife Katelina.',
    'Изнад јужне певнице налази се фигура пророка Гедеона, која је добро очувана. На златној позадини ове фреске исцртани су квадратићи како би се постигао изглед мозаика. Сматра се су тако изгледале позадине свих фресака у овој цркви.': 'Above the southern choir is the figure of the prophet Gideon, which is well preserved. On the golden background of this fresco, squares are drawn to achieve the appearance of a mosaic. It is believed that the backgrounds of all the frescoes in this church looked like this.',
    'Фигура Богородице у проскомидији и фигура мртвог Христа у ђаконикону део су јединствене сцене Оплакивања, насликане по први пут на зиду управо у оквиру градачког фрескописа.': 'The figure of the Theotokos in the proskomedia and the figure of the dead Christ in the diaconicon are part of a unique scene of Lamentation, painted for the first time on a wall precisely within the Gradac fresco painting.',
    'Црква Светог Николе фрескописана је вероватно у XIV веку. Фреске су делимично сачуване. Велико попрсје Светог Николе, којег је краљица Јелена посебно поштовала, насликано је на јужној страни, а најбоље је очувана фигура анђела у олтару.': 'The Church of Saint Nicholas was probably painted with frescoes in the 14th century. The frescoes are partially preserved. A large bust of Saint Nicholas, whom Queen Jelena particularly venerated, is painted on the south side, and the best-preserved figure is an angel in the altar.',
    'Благовести — портал': 'Annunciation — portal',
    'Богородица из Благовести': 'Theotokos from the Annunciation',
    'Распеће — детаљ, Христос': 'Crucifixion — detail, Christ',
    'Распеће — детаљ, Св. Јован': 'Crucifixion — detail, St. John',
    'Распеће — детаљ, Свете жене': 'Crucifixion — detail, Holy Women',
    'Олтар — Оплакивање, Христос': 'Altar — Lamentation, Christ',
    'Олтар — Оплакивање, Богородица': 'Altar — Lamentation, Theotokos',
    'Пренос моштију': 'Translation of Relics',
    'Припрата — Миловање': 'Narthex — Caressing',
    'Припрата — Сусрет Јоакима и Ане': 'Narthex — Meeting of Joachim and Anne',
    'Припрата — Рођење Богородице': 'Narthex — Nativity of the Theotokos',
    'Припрата — Улазак у Храм': 'Narthex — Presentation of the Theotokos in the Temple',
    'Припрата — Молитва Св. Ане': 'Narthex — Prayer of St. Anne',
    'Припрата — Благослов': 'Narthex — Blessing',
    'Бегство у Египат': 'Flight into Egypt',
    'Васкрсење Лазарево': 'Raising of Lazarus',
    'Васкрсење Лазарево — детаљ': 'Raising of Lazarus — detail',
    'Свирач у двојнице': 'Double-flute Player',
    'Пророци': 'Prophets',
    'Успење — детаљ': 'Dormition — detail',
    // Footer legal links
    'Политика приватности': 'Privacy Policy',
    'Колачићи': 'Cookies',
    'Услови коришћења': 'Terms of Use',
    'Заслуге за фотографије': 'Photo Credits',
    'Јавне набавке': 'Public Procurements',
    'Посета': 'Visit',
    // Hero
    'Српски православни манастир Светих Благовести': 'Serbian Orthodox Monastery of the Holy Annunciation',
    'Градац': 'Gradac',
    // Footer address
    'Манастир Градац, 36346 Брвеник, Рашка, Србија': 'Gradac Monastery, 36346 Brvenik, Raška, Serbia',
    // News
    'Читати даље →': 'Read more →',
    // CategoryPage section titles
    'Историја и оснивање': 'History and Foundation',
    'Архитектура храма': 'Temple Architecture',
    'Планирајте посету': 'Plan Your Visit',
    // Legal pages
    'Последње ажурирање': 'Last updated',
    'Политика колачића': 'Cookie Policy',
    // PostCards
    'Погледајте галерију': 'View Gallery',
    // VisitPage
    'Посета Манастиру': 'Visiting the Monastery',
    'Локација': 'Location',
    'Временска прогноза': 'Weather Forecast',
    'Тренутно': 'Currently',
    'Данас': 'Today',
    'Градац, Србија': 'Gradac, Serbia',
    'Тренутно није могуће учитати временску прогнозу.': 'Weather forecast is currently unavailable.',
    // Weather labels
    'Ведро': 'Clear',
    'Делимично облачно': 'Partly Cloudy',
    'Магла': 'Fog',
    'Ситна киша': 'Drizzle',
    'Ледена киша': 'Freezing Rain',
    'Киша': 'Rain',
    'Снег': 'Snow',
    'Снежна зрна': 'Snow Grains',
    'Пљусак': 'Rain Shower',
    'Снежни пљусак': 'Snow Shower',
    'Грмљавина': 'Thunderstorm',
    'Непознато': 'Unknown',
    // Day names
    'Нед': 'Sun',
    'Пон': 'Mon',
    'Уто': 'Tue',
    'Сре': 'Wed',
    'Чет': 'Thu',
    'Пет': 'Fri',
    'Суб': 'Sat',
    // CategoryPage extras
    'Назад': 'Back',
    'Претходна': 'Previous',
    'Следећа': 'Next',
    'Слика': 'Image',
  },
  de: {
    'Манастир Градац': 'Kloster Gradac',
    'О Манастиру': 'Über das Kloster',
    'О МАНАСТИРУ ГРАДАЦ': 'ÜBER DAS KLOSTER GRADAC',
    'Подкатегорије': 'Unterkategorien',
    'Фото галерија': 'Fotogalerie',
    'Галерија': 'Galerie',
    'Новости': 'Nachrichten',
    'Јавне испоруке': 'Öffentliche Lieferungen',
    'Долина јоргована': 'Tal der Flieder',
    'Задужбина Свете краљице Јелене Анжујске': 'Stiftung der Heiligen Königin Jelena Anžujska',
    'Православни манастир из XIII века, смештен у долини реке Ибар на обронцима Голије.': 'Ein orthodoxes Kloster aus dem 13. Jahrhundert, gelegen im Tal des Flusses Ibar an den Hängen von Golija.',
    'Навигација': 'Navigation',
    'Почетна': 'Startseite',
    'Контакт': 'Kontakt',
    'Брвеник, Рашка, Србија': 'Brvenik, Raška, Serbien',
    '© 2026 Манастир Градац. Сва права задржана.': '© 2026 Kloster Gradac. Alle Rechte vorbehalten.',
    'Фотографије: Светлана Дингарац': 'Fotos: Svetlana Dingarac',
    'Богослужбени Распоред': 'Gottesdienstplan',
    'Учитавање...': 'Laden...',
    'Покушај поново': 'Erneut versuchen',
    'Грешка при учитавању распореда.': 'Fehler beim Laden des Plans.',
    'Грешка при учитавању.': 'Fehler beim Laden.',
    'Донирајте манастиру': 'Spenden an das Kloster',
    'Контакт за донације и помоћ манастиру': 'Kontakt für Spenden und Klosterunterstützung',
    'Манастир Градац — донације за обнову манастира': 'Kloster Gradac — Spenden für die Klosterrestaurierung',
    'Сачувај': 'Speichern',
    'Откажи': 'Abbrechen',
    'Сачувано ✓': 'Gespeichert ✓',
    'Измени': 'Bearbeiten',
    'НОВОСТИ МАНАСТИРА ГРАДАЦ': 'NACHRICHTEN DES KLOSTERS GRADAC',
    'Читати даље': 'Weiterlesen',
    'Уреди': 'Bearbeiten',
    '+ Додај вест': '+ Nachricht hinzufügen',
    'СВЕ НОВОСТИ': 'ALLE NACHRICHTEN',
    'Наслов': 'Titel',
    'Опис': 'Beschreibung',
    'Прочитај више': 'Mehr lesen',
    '+ Додај': '+ Hinzufügen',
    'СВА ГАЛЕРИЈА': 'GESAMTE GALERIE',
    'Како до нас': 'So finden Sie uns',
    'Наручи производ': 'Produkt bestellen',
    'Затвори': 'Schließen',
    'Хвала!': 'Danke!',
    'Наручивање': 'Bestellung',
    'Име и презиме': 'Vollständiger Name',
    'Телефон': 'Telefon',
    'Имејл': 'E-Mail',
    'Адреса за испоруку': 'Lieferadresse',
    'Количина': 'Menge',
    'Напомена': 'Anmerkung',
    'Пошаљи наруџбину': 'Bestellung senden',
    '← Назад': '← Zurück',
    'Страница није пронађена': 'Seite nicht gefunden',
    'Назад на почетну': 'Zurück zur Startseite',
    'Датум': 'Datum',
    'НАРУЏБИНЕ': 'BESTELLUNGEN',
    'Чување...': 'Speichern...',
    'Слање...': 'Senden...',
    'Додај': 'Hinzufügen',
    'Обриши': 'Löschen',
    'Важно': 'Wichtig',
    // Footer legal links
    'Политика приватности': 'Datenschutzrichtlinie',
    'Колачићи': 'Cookies',
    'Услови коришћења': 'Nutzungsbedingungen',
    'Заслуге за фотографије': 'Bildnachweise',
    'Јавне набавке': 'Öffentliche Beschaffungen',
    'Посета': 'Besuch',
    // Hero
    'Српски православни манастир Светих Благовести': 'Serbisch-orthodoxes Kloster der Heiligen Verkündigung',
    'Градац': 'Gradac',
    // Footer address
    'Манастир Градац, 36346 Брвеник, Рашка, Србија': 'Kloster Gradac, 36346 Brvenik, Raška, Serbien',
    // News
    'Читати даље →': 'Weiterlesen →',
    // CategoryPage section titles
    'Историја и оснивање': 'Geschichte und Gründung',
    'Архитектура храма': 'Tempelarchitektur',
    'Планирајте посету': 'Planen Sie Ihren Besuch',
    'Последње ажурирање': 'Letzte Aktualisierung',
    'Политика колачића': 'Cookie-Richtlinie',
    // FrescoesPage
    'Фрескопис': 'Freskenmalerei',
    // PostCards
    'Погледајте галерију': 'Galerie ansehen',
    // VisitPage
    'Посета Манастиру': 'Klosterbesuch',
    'Локација': 'Standort',
    'Временска прогноза': 'Wettervorhersage',
    'Тренутно': 'Aktuell',
    'Данас': 'Heute',
    'Градац, Србија': 'Gradac, Serbien',
    'Тренутно није могуће учитати временску прогнозу.': 'Die Wettervorhersage ist derzeit nicht verfügbar.',
    // Weather labels
    'Ведро': 'Klar',
    'Делимично облачно': 'Teilweise bewölkt',
    'Магла': 'Nebel',
    'Ситна киша': 'Nieselregen',
    'Ледена киша': 'Eisregen',
    'Киша': 'Regen',
    'Снег': 'Schnee',
    'Снежна зрна': 'Schneekörner',
    'Пљусак': 'Regenschauer',
    'Снежни пљусак': 'Schneeschauer',
    'Грмљавина': 'Gewitter',
    'Непознато': 'Unbekannt',
    // Day names
    'Нед': 'So',
    'Пон': 'Mo',
    'Уто': 'Di',
    'Сре': 'Mi',
    'Чет': 'Do',
    'Пет': 'Fr',
    'Суб': 'Sa',
    // CategoryPage extras
    'Назад': 'Zurück',
    'Претходна': 'Vorherige',
    'Следећа': 'Nächste',
    'Слика': 'Bild',
  },
  fr: {
    'Манастир Градац': 'Monastère de Gradac',
    'О Манастиру': 'À propos du monastère',
    'О МАНАСТИРУ ГРАДАЦ': 'À PROPOS DU MONASTÈRE DE GRADAC',
    'Подкатегорије': 'Sous-catégories',
    'Фото галерија': 'Galerie de photos',
    'Галерија': 'Galerie',
    'Новости': 'Actualités',
    'Јавне испоруке': 'Livraisons publiques',
    'Долина јоргована': 'Vallée des Lilas',
    'Задужбина Свете краљице Јелене Анжујске': 'Fondation de la Sainte Reine Jelena Anžujska',
    'Православни манастир из XIII века, смештен у долини реке Ибар на обронцима Голије.': 'Un monastère orthodoxe du XIIIe siècle, niché dans la vallée de la rivière Ibar sur les pentes de Golija.',
    'Навигација': 'Navigation',
    'Почетна': 'Accueil',
    'Контакт': 'Contact',
    'Брвеник, Рашка, Србија': 'Brvenik, Raška, Serbie',
    '© 2026 Манастир Градац. Сва права задржана.': '© 2026 Monastère de Gradac. Tous droits réservés.',
    'Фотографије: Светлана Дингарац': 'Photos : Svetlana Dingarac',
    'Богослужбени Распоред': 'Horaire des offices',
    'Учитавање...': 'Chargement...',
    'Покушај поново': 'Réessayer',
    'Грешка при учитавању.': 'Erreur de chargement.',
    'Донирајте манастиру': 'Faire un don au monastère',
    'Контакт за донације и помоћ манастиру': 'Contact pour les dons et le soutien au monastère',
    'Сачувај': 'Enregistrer',
    'Откажи': 'Annuler',
    'НОВОСТИ МАНАСТИРА ГРАДАЦ': 'ACTUALITÉS DU MONASTÈRE DE GRADAC',
    'Читати даље': 'Lire la suite',
    'Уреди': 'Modifier',
    'СВЕ НОВОСТИ': 'TOUTES LES ACTUALITÉS',
    'Наслов': 'Titre',
    'Опис': 'Description',
    'Прочитај више': 'En savoir plus',
    'СВА ГАЛЕРИЈА': 'GALERIE COMPLÈTE',
    'Како до нас': 'Comment nous trouver',
    'Затвори': 'Fermer',
    'Хвала!': 'Merci !',
    'Наручивање': 'Commande',
    'Име и презиме': 'Nom complet',
    'Телефон': 'Téléphone',
    'Имејл': 'E-mail',
    'Количина': 'Quantité',
    'Напомена': 'Remarque',
    'Пошаљи наруџбину': 'Envoyer la commande',
    '← Назад': '← Retour',
    'Страница није пронађена': 'Page non trouvée',
    'Назад на почетну': "Retour à l'accueil",
    'Датум': 'Date',
    'Додај': 'Ajouter',
    'Обриши': 'Supprimer',
    'Важно': 'Important',
    // Footer legal links
    'Политика приватности': 'Politique de confidentialité',
    'Колачићи': 'Cookies',
    'Услови коришћења': "Conditions d'utilisation",
    'Заслуге за фотографије': 'Crédits photos',
    'Јавне набавке': 'Marchés publics',
    'Посета': 'Visite',
    // Hero
    'Српски православни манастир Светих Благовести': 'Monastère orthodoxe serbe de la Sainte Annonciation',
    'Градац': 'Gradac',
    // Footer address
    'Манастир Градац, 36346 Брвеник, Рашка, Србија': 'Monastère de Gradac, 36346 Brvenik, Raška, Serbie',
    // News
    'Читати даље →': 'Lire la suite →',
    // CategoryPage section titles
    'Историја и оснивање': 'Histoire et fondation',
    'Архитектура храма': 'Architecture du temple',
    'Планирајте посету': 'Planifiez votre visite',
    'Последње ажурирање': 'Dernière mise à jour',
    'Политика колачића': 'Politique de cookies',
    // FrescoesPage
    'Фрескопис': 'Fresques',
    // PostCards
    'Погледајте галерију': 'Voir la galerie',
    // VisitPage
    'Посета Манастиру': 'Visite du monastère',
    'Локација': 'Emplacement',
    'Временска прогноза': 'Prévisions météo',
    'Тренутно': 'Actuellement',
    'Данас': "Aujourd'hui",
    'Градац, Србија': 'Gradac, Serbie',
    'Тренутно није могуће учитати временску прогнозу.': 'Les prévisions météo sont actuellement indisponibles.',
    // Weather labels
    'Ведро': 'Dégagé',
    'Делимично облачно': 'Partiellement nuageux',
    'Магла': 'Brouillard',
    'Ситна киша': 'Bruine',
    'Ледена киша': 'Pluie verglaçante',
    'Киша': 'Pluie',
    'Снег': 'Neige',
    'Снежна зрна': 'Grains de neige',
    'Пљусак': 'Averse',
    'Снежни пљусак': 'Averse de neige',
    'Грмљавина': 'Orage',
    'Непознато': 'Inconnu',
    // Day names
    'Нед': 'Dim',
    'Пон': 'Lun',
    'Уто': 'Mar',
    'Сре': 'Mer',
    'Чет': 'Jeu',
    'Пет': 'Ven',
    'Суб': 'Sam',
    // CategoryPage extras
    'Назад': 'Retour',
    'Претходна': 'Précédente',
    'Следећа': 'Suivante',
    'Слика': 'Image',
  },
  it: {
    'Манастир Градац': 'Monastero di Gradac',
    'О Манастиру': 'Informazioni sul monastero',
    'О МАНАСТИРУ ГРАДАЦ': 'SUL MONASTERO DI GRADAC',
    'Подкатегорије': 'Sottocategorie',
    'Фото галерија': 'Galleria fotografica',
    'Галерија': 'Galleria',
    'Новости': 'Notizie',
    'Јавне испоруке': 'Consegne pubbliche',
    'Долина јоргована': 'Valle dei Lillà',
    'Задужбина Свете краљице Јелене Анжујске': 'Fondazione della Santa Regina Jelena Anžujska',
    'Православни манастир из XIII века, смештен у долини реке Ибар на обронцима Голије.': 'Un monastero ortodosso del XIII secolo, situato nella valle del fiume Ibar sulle pendici di Golija.',
    'Навигација': 'Navigazione',
    'Почетна': 'Home',
    'Контакт': 'Contatto',
    'Брвеник, Рашка, Србија': 'Brvenik, Raška, Serbia',
    '© 2026 Манастир Градац. Сва права задржана.': '© 2026 Monastero di Gradac. Tutti i diritti riservati.',
    'Фотографије: Светлана Дингарац': 'Foto: Svetlana Dingarac',
    'Богослужбени Распоред': 'Orario delle funzioni',
    'Учитавање...': 'Caricamento...',
    'Покушај поново': 'Riprova',
    'Грешка при учитавању.': 'Errore di caricamento.',
    'Донирајте манастиру': 'Dona al monastero',
    'Сачувај': 'Salva',
    'Откажи': 'Annulla',
    'НОВОСТИ МАНАСТИРА ГРАДАЦ': 'NOTIZIE DEL MONASTERO DI GRADAC',
    'Читати даље': 'Continua a leggere',
    'Уреди': 'Modifica',
    'СВЕ НОВОСТИ': 'TUTTE LE NOTIZIE',
    'Наслов': 'Titolo',
    'Опис': 'Descrizione',
    'Прочитај више': 'Per saperne di più',
    'СВА ГАЛЕРИЈА': 'GALLERIA COMPLETA',
    'Како до нас': 'Come raggiungerci',
    'Затвори': 'Chiudi',
    'Хвала!': 'Grazie!',
    'Наручивање': 'Ordinazione',
    'Име и презиме': 'Nome completo',
    'Телефон': 'Telefono',
    'Имејл': 'E-mail',
    'Количина': 'Quantità',
    'Напомена': 'Nota',
    'Пошаљи наруџбину': "Invia l'ordine",
    '← Назад': '← Indietro',
    'Страница није пронађена': 'Pagina non trovata',
    'Назад на почетну': 'Torna alla home',
    'Датум': 'Data',
    'Додај': 'Aggiungi',
    'Обриши': 'Elimina',
    'Важно': 'Importante',
    // Footer legal links
    'Политика приватности': 'Informativa sulla privacy',
    'Колачићи': 'Cookie',
    'Услови коришћења': "Termini d'uso",
    'Заслуге за фотографије': 'Crediti fotografici',
    'Јавне набавке': 'Appalti pubblici',
    'Посета': 'Visita',
    // Hero
    'Српски православни манастир Светих Благовести': 'Monastero ortodosso serbo della Santa Annunciazione',
    'Градац': 'Gradac',
    // Footer address
    'Манастир Градац, 36346 Брвеник, Рашка, Србија': 'Monastero di Gradac, 36346 Brvenik, Raška, Serbia',
    // News
    'Читати даље →': 'Continua a leggere →',
    // CategoryPage section titles
    'Историја и оснивање': 'Storia e fondazione',
    'Архитектура храма': 'Architettura del tempio',
    'Планирајте посету': 'Pianifica la tua visita',
    'Последње ажурирање': 'Ultimo aggiornamento',
    'Политика колачића': 'Politica dei cookie',
    // FrescoesPage
    'Фрескопис': 'Affreschi',
    // PostCards
    'Погледајте галерију': 'Vedi la galleria',
    // VisitPage
    'Посета Манастиру': 'Visita al monastero',
    'Локација': 'Posizione',
    'Временска прогноза': 'Previsioni meteo',
    'Тренутно': 'Attualmente',
    'Данас': 'Oggi',
    'Градац, Србија': 'Gradac, Serbia',
    'Тренутно није могуће учитати временску прогнозу.': 'Le previsioni meteo non sono attualmente disponibili.',
    // Weather labels
    'Ведро': 'Sereno',
    'Делимично облачно': 'Parzialmente nuvoloso',
    'Магла': 'Nebbia',
    'Ситна киша': 'Pioviggine',
    'Ледена киша': 'Pioggia gelata',
    'Киша': 'Pioggia',
    'Снег': 'Neve',
    'Снежна зрна': 'Granuli di neve',
    'Пљусак': 'Acquazzone',
    'Снежни пљусак': 'Rovescio di neve',
    'Грмљавина': 'Temporale',
    'Непознато': 'Sconosciuto',
    // Day names
    'Нед': 'Dom',
    'Пон': 'Lun',
    'Уто': 'Mar',
    'Сре': 'Mer',
    'Чет': 'Gio',
    'Пет': 'Ven',
    'Суб': 'Sab',
    // CategoryPage extras
    'Назад': 'Indietro',
    'Претходна': 'Precedente',
    'Следећа': 'Successiva',
    'Слика': 'Immagine',
  },
  el: {
    'Манастир Градац': 'Μοναστήρι Γκράνταρτς',
    'О Манастиру': 'Σχετικά με το Μοναστήρι',
    'О МАНАСТИРУ ГРАДАЦ': 'ΣΧΕΤΙΚΑ ΜΕ ΤΟ ΜΟΝΑΣΤΗΡΙ',
    'Подкатегорије': 'Υποκατηγορίες',
    'Фото галерија': 'Γκαλερί φωτογραφιών',
    'Галерија': 'Γκαλερί',
    'Новости': 'Νέα',
    'Јавне испоруке': 'Δημόσιες Παραδόσεις',
    'Долина јоргована': 'Κοιλάδα των Πασχαλιών',
    'Задужбина Свете краљице Јелене Анжујске': 'Ίδρυμα της Αγίας Βασίλισσας Jelena Anžujska',
    'Православни манастир из XIII века, смештен у долини реке Ибар на обронцима Голије.': 'Ένα ορθόδοξο μοναστήρι του 13ου αιώνα, στην κοιλάδα του ποταμού Ibar στις πλαγιές της Golija.',
    'Навигација': 'Πλοήγηση',
    'Почетна': 'Αρχική',
    'Контакт': 'Επικοινωνία',
    'Брвеник, Рашка, Србија': 'Μπρβένικ, Ράσκα, Σερβία',
    '© 2026 Манастир Градац. Сва права задржана.': '© 2026 Μοναστήρι Γκράνταρτς. Με επιφύλαξη παντός δικαιώματος.',
    'Фотографије: Светлана Дингарац': 'Φωτογραφίες: Svetlana Dingarac',
    'Богослужбени Распоред': 'Πρόγραμμα Λειτουργιών',
    'Учитавање...': 'Φόρτωση...',
    'Покушај поново': 'Δοκιμάστε ξανά',
    'Грешка при учитавању.': 'Σφάλμα φόρτωσης.',
    'Донирајте манастиру': 'Δωρεά στο Μοναστήρι',
    'Сачувај': 'Αποθήκευση',
    'Откажи': 'Ακύρωση',
    'НОВОСТИ МАНАСТИРА ГРАДАЦ': 'ΝΕΑ ΤΟΥ ΜΟΝΑΣΤΗΡΙΟΥ ΓΚΡΑΝΤΑΡΤΣ',
    'Читати даље': 'Διαβάστε περισσότερα',
    'Уреди': 'Επεξεργασία',
    'СВЕ НОВОСТИ': 'ΟΛΑ ΤΑ ΝΕΑ',
    'Наслов': 'Τίτλος',
    'Опис': 'Περιγραφή',
    'Прочитај више': 'Περισσότερα',
    'СВА ГАЛЕРИЈА': 'ΠΛΗΡΗΣ ΓΚΑΛΕΡΙ',
    'Како до нас': 'Πώς να μας βρείτε',
    'Затвори': 'Κλείσιμο',
    'Хвала!': 'Ευχαριστούμε!',
    'Наручивање': 'Παραγγελία',
    'Име и презиме': 'Ονοματεπώνυμο',
    'Телефон': 'Τηλέφωνο',
    'Имејл': 'E-mail',
    'Количина': 'Ποσότητα',
    'Напомена': 'Σημείωση',
    'Пошаљи наруџбину': 'Αποστολή παραγγελίας',
    '← Назад': '← Πίσω',
    'Страница није пронађена': 'Η σελίδα δεν βρέθηκε',
    'Назад на почетну': 'Επιστροφή στην αρχική',
    'Датум': 'Ημερομηνία',
    'Додај': 'Προσθήκη',
    'Обриши': 'Διαγραφή',
    'Важно': 'Σημαντικό',
    // Footer legal links
    'Политика приватности': 'Πολιτική Απορρήτου',
    'Колачићи': 'Cookies',
    'Услови коришћења': 'Όροι Χρήσης',
    'Заслуге за фотографије': 'Πιστώσεις Φωτογραφιών',
    'Јавне набавке': 'Δημόσιες Προμήθειες',
    'Посета': 'Επίσκεψη',
    // Hero
    'Српски православни манастир Светих Благовести': 'Σερβικό Ορθόδοξο Μοναστήρι του Ευαγγελισμού',
    'Градац': 'Γκράνταρτς',
    // Footer address
    'Манастир Градац, 36346 Брвеник, Рашка, Србија': 'Μοναστήρι Γκράνταρτς, 36346 Μπρβένικ, Ράσκα, Σερβία',
    // News
    'Читати даље →': 'Διαβάστε περισσότερα →',
    // CategoryPage section titles
    'Историја и оснивање': 'Ιστορία και ίδρυση',
    'Архитектура храма': 'Αρχιτεκτονική του ναού',
    'Планирајте посету': 'Σχεδιάστε την επίσκεψή σας',
    'Последње ажурирање': 'Τελευταία ενημέρωση',
    'Политика колачића': 'Πολιτική Cookies',
    // FrescoesPage
    'Фрескопис': 'Αγιογραφίες',
    // PostCards
    'Погледајте галерију': 'Δείτε τη γκαλερί',
    // VisitPage
    'Посета Манастиру': 'Επίσκεψη στο Μοναστήρι',
    'Локација': 'Τοποθεσία',
    'Временска прогноза': 'Πρόγνωση καιρού',
    'Тренутно': 'Τώρα',
    'Данас': 'Σήμερα',
    'Градац, Србија': 'Γκράνταρτς, Σερβία',
    'Тренутно није могуће учитати временску прогнозу.': 'Η πρόγνωση καιρού δεν είναι διαθέσιμη αυτή τη στιγμή.',
    // Weather labels
    'Ведро': 'Αίθριος',
    'Делимично облачно': 'Μερικώς νεφελώδης',
    'Магла': 'Ομίχλη',
    'Ситна киша': 'Ψιχάλα',
    'Ледена киша': 'Παγωμένη βροχή',
    'Киша': 'Βροχή',
    'Снег': 'Χιόνι',
    'Снежна зрна': 'Χιονόκοκκοι',
    'Пљусак': 'Μπόρα',
    'Снежни пљусак': 'Χιονόνερο',
    'Грмљавина': 'Καταιγίδα',
    'Непознато': 'Άγνωστο',
    // Day names
    'Нед': 'Κυρ',
    'Пон': 'Δευ',
    'Уто': 'Τρί',
    'Сре': 'Τετ',
    'Чет': 'Πέμ',
    'Пет': 'Παρ',
    'Суб': 'Σάβ',
    // CategoryPage extras
    'Назад': 'Πίσω',
    'Претходна': 'Προηγούμενη',
    'Следећа': 'Επόμενη',
    'Слика': 'Εικόνα',
  },
};

/**
 * Look up a pre-translated UI string.
 * Returns the translation if found, or undefined if not in the dictionary.
 */
export const lookupTranslation = (text: string, lang: string): string | undefined => {
  return translations[lang]?.[text];
};

export default translations;
